import React from 'react';
import { Switch } from '@headlessui/react';

export const InputSwitch = ({
    enabled,
    setEnabled,
    label,
    disabled,
    compact,
    hideLabel = false,
}) => {
    const switchControl = (
        <Switch
            checked={enabled}
            onChange={setEnabled}
            disabled={disabled}
            className={`${enabled ? 'bg-indigo-600' : 'bg-gray-200'
                } relative inline-flex h-6 w-11 shrink-0 items-center rounded-full disabled:opacity-50`}
        >
            {hideLabel && label ? (
                <span className="sr-only">{label}</span>
            ) : null}
            <span
                className={`${enabled ? 'translate-x-6' : 'translate-x-1'
                    } inline-block h-4 w-4 transform rounded-full bg-white transition`}
            />
        </Switch>
    );

    if (hideLabel) {
        return switchControl;
    }

    return (
        <div className={`flex justify-between gap-4 ${compact ? 'my-0 items-center' : 'my-2'}`}>
            <label
                htmlFor={""}
                className={`${disabled ? 'text-gray-400' : 'text-gray-900'} ${compact ? 'text-[13px] mb-0 font-semibold' : 'text-[16px] mb-2 font-medium'} leading-6`}
            >
                {label}
            </label>
            {switchControl}
        </div>
    );
};
